import './Messagerie.css';

/**
 * Un bloc de pièces d'un nouveau message — images intégrées au texte ou
 * documents téléchargeables.
 *
 * `avecMarqueur` distingue les deux usages : une image se réfère depuis le
 * texte par `[image:N]` et propose donc « Insérer ici », un document se lit
 * en pièce jointe et n'a rien à faire dans le texte.
 */
export default function BlocPieces({
  titre, items, onAjouter, onRetirer, onInserer, accept, videTexte, avecMarqueur = false,
}) {
  return (
    <div className="pieces-mail">
      <div className="pieces-mail__entete">
        <strong>{titre}</strong>
        {/* Un vrai bouton pour le clavier : il ouvre le sélecteur de fichiers caché. */}
        <label className="btn btn-outline btn-sm pieces-mail__ajouter">
          Ajouter {avecMarqueur ? 'des images' : 'des documents'}
          <input
            type="file"
            accept={accept}
            multiple
            className="pieces-mail__fichier"
            onChange={(e) => {
              onAjouter(Array.from(e.target.files ?? []));
              e.target.value = '';
            }}
          />
        </label>
      </div>

      {items.length === 0 ? (
        <p className="pieces-mail__vide">{videTexte}</p>
      ) : (
        <ul className="pieces-mail__liste">
          {items.map((f, i) => (
            // Une pièce enregistrée a un identifiant stable ; un fichier tout
            // juste choisi n'a que son nom et sa place.
            <li key={f.id ?? `${f.name}-${i}`}>
              {avecMarqueur && <span className="pieces-mail__rang">[image:{i + 1}]</span>}
              <span className="pieces-mail__nom">
                {avecMarqueur ? '' : '📎 '}{f.name}
              </span>
              <span className="pieces-mail__poids">{Math.max(1, Math.round(f.size / 1024))} Ko</span>

              {avecMarqueur && (
                <button
                  type="button"
                  className="btn-ghost btn-ghost--mini"
                  onClick={() => onInserer(i + 1)}
                >
                  Insérer ici
                </button>
              )}

              <button
                type="button"
                className="btn-ghost btn-ghost--mini btn-ghost--danger"
                onClick={() => onRetirer(i)}
              >
                Retirer
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
